export enum USER_GROUP_MEMBER_TYPE {
  OWNER = 1,
  TEAM_MEMBER = 2,
}
